import { voidfallChapters } from './content';
export const voidfallQuickReference = voidfallChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('QUICK REFERENCE'));
